"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  SavingPiggyBank: ['saving-piggy-bank', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,9.5a3,3,0,0,1-3,3', 'M8.25,8a6.763,6.763,0,0,1,6,0', 'M6.375,11a.375.375,0,1,0,.375.375A.375.375,0,0,0,6.375,11', 'M7.9,4.883C6.726,2.756,3.75,2.75,3.75,2.75l.626,4.384A8.058,8.058,0,0,0,2.6,10.25H.75v6H3.24a8.467,8.467,0,0,0,2.01,2.372V21.5a.75.75,0,0,0,.75.75H7.5a.75.75,0,0,0,.75-.75V20.259a9.512,9.512,0,0,0,6,.011V21.5a.75.75,0,0,0,.75.75h1.5a.75.75,0,0,0,.75-.75V18.637a7.941,7.941,0,0,0,3-6.137C20.25,6.006,13.2,3.111,7.9,4.883Z']],
  SavingPiggyDollars: ['saving-piggy-dollars', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25,19.637a8.228,8.228,0,0,0,2.62-3.765', 'M7.5,10.125a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M18.75,3.75H16.717a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H15.75', 'M17.25 3.75L17.25 3', 'M17.25 10.5L17.25 9.75', 'M11.250 6.750 A6.000 6.000 0 1 0 23.250 6.750 A6.000 6.000 0 1 0 11.250 6.750 Z', 'M9.037,5.531,7.054,3.878a.75.75,0,0,0-1.224.484L5.474,7.206A8.22,8.22,0,0,0,2.6,11.25H.75v6H3.24a9.114,9.114,0,0,0,8.01,4.5,8.911,8.911,0,0,0,8.689-6.092', 'M6.011 20.204L5.25 23.25', 'M16.49 20.209L17.25 23.25']],
  SavingPiggyCoins: ['saving-piggy-coins', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.363,8.192A9.019,9.019,0,0,1,12.75,2.918a9.628,9.628,0,0,1,2.213.282L16.946.926a.749.749,0,0,1,1.224.485l.356,3.471A8.261,8.261,0,0,1,21.4,8.945H23.25v6.028H20.76a8.433,8.433,0,0,1-2.01,2.4,8.91,8.91,0,0,1-2.925,1.611', 'M0.750 14.250 A6 3 0 1 0 12.750 14.250 A6 3 0 1 0 0.750 14.250 Z', 'M12.75,14.25v6c0,1.657-2.686,3-6,3s-6-1.343-6-3v-6', 'M.75,17.25c0,1.657,2.686,3,6,3s6-1.343,6-3', 'M16.875,7.5a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M17.957 17.956L18.75 21']],
  SavingBagIncrease: ['saving-bag-increase', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.16,16a.638.638,0,0,0-.66.609V21.4a.628.628,0,0,0,.65.6h8.44a.638.638,0,0,0,.66-.609V16.75a.784.784,0,0,0-.813-.75Z', 'M18.375,18.631A.369.369,0,1,1,18,19a.372.372,0,0,1,.375-.369', 'M13.5,18.853A7.289,7.289,0,0,1,7.5,22C4.111,22,.75,19.482.75,16.375c0-3.068,2.659-6.458,4.705-7.875C4.865,7.2,4.39,6.175,4.02,5.385A1.5,1.5,0,0,1,5.379,3.25H10.5', 'M11.8,10.646A10.1,10.1,0,0,1,14.237,16', 'M5.829,17.844a2.224,2.224,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547s-.924-1.546-2.063-1.546-2.062-.693-2.062-1.548.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M7.687 18.719L7.687 19.75', 'M7.687 11.5L7.687 12.531', 'M23.25 5.286L23.25 1.75 19.714 1.75', 'M23.25,1.753,20,5a1.444,1.444,0,0,1-1.438.363l-3.671-.981a1.449,1.449,0,0,0-1.4.375L9.745,8.507']],
  SavingBankCash: ['saving-bank-cash', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-1.125 13.125) rotate(-90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.25 23.25L23.25 23.25', 'M15.575,6.572l7.406,4.937a.6.6,0,0,1,.269.5V12.9a.6.6,0,0,1-.6.6H5.25', 'M2.625 1.875 L9.375 1.875 L9.375 12.375 L2.625 12.375 Z', 'M4.443,3.75l.3-2.009A1.163,1.163,0,0,1,6.066.763l6.769,1.013A1.163,1.163,0,0,1,13.813,3.1l-.529,3.531a1.187,1.187,0,0,1-2.034.625', 'M6,6.75a.375.375,0,1,1-.375.375A.375.375,0,0,1,6,6.75', 'M21 23.25L21 13.5', 'M16.5 23.25L16.5 13.5', 'M12 23.25L12 13.5', 'M7.5 23.25L7.5 13.5']],
  SavingBankDrawer: ['saving-bank-drawer', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.75 0.75L9.75 23.25', 'M0.75 8.25L18.75 8.25', 'M0.75 15.75L18.75 15.75', 'M18.75,2.3A1.776,1.776,0,0,0,17.25.75h-15A1.776,1.776,0,0,0,.75,2.3V21.7a1.776,1.776,0,0,0,1.5,1.552h15a1.776,1.776,0,0,0,1.5-1.552Z', 'M23.25,16.056a.749.749,0,0,1-.959.72L18.75,15.75V8.25l3.611-.583a.75.75,0,0,1,.889.737Z', 'M4.125,4.5a.375.375,0,1,1-.375.375A.375.375,0,0,1,4.125,4.5', 'M4.125,12a.375.375,0,1,1-.375.375A.375.375,0,0,1,4.125,12', 'M4.125,19.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M13.125,19.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M12.982,4.529a.374.374,0,1,1-.2.489.374.374,0,0,1,.2-.489', 'M12 15.75L12.9 12.75 15.6 12.75 16.5 15.75 12 15.75z']],
  SavingBull: ['saving-bull', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(7.863 21.861) rotate(-73.7)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.889,20.353l.561.253a1.5,1.5,0,0,1,.9,1.373V22.5a.75.75,0,0,0,.75.75h.914a.751.751,0,0,0,.728-.568l.467-1.87a1.5,1.5,0,0,0-.133-1.073l-.269-.5a4.993,4.993,0,0,1-.5-2.428,3.693,3.693,0,0,0-.39-1.678h0A3.691,3.691,0,0,0,19.3,13.157L17.9,12.888a2.06,2.06,0,0,1-.955-.54l-1.226-1.227A7.242,7.242,0,0,0,10.6,9h0a5.934,5.934,0,0,0-3.643,1.25L3.172,13.182', 'M5.346,15a5.5,5.5,0,0,1-2.784,3.267h0a.825.825,0,0,1-1.178-.576c-.6-2.99-.566-2.812-.566-2.812', 'M2.168,15.506c.332.055.755-.929.832-1.256a5.086,5.086,0,0,0-.917-4.5L.8,14.25C.543,15.115,1.277,15.357,2.168,15.506Z', 'M16.641 5.684 A1.875 1.125 0 1 0 20.391 5.684 A1.875 1.125 0 1 0 16.641 5.684 Z', 'M17.99,7.484h0a2.105,2.105,0,0,0,1.68,2.653l1.093.183a2.534,2.534,0,0,1,1.692,1.094h0a2.532,2.532,0,0,1,.062,2.712l-.605,1.006', 'M4.605,16.5l3.128,1.043A1.5,1.5,0,0,1,8.7,19.381l-.832,2.913a.75.75,0,0,0,.721.956h1.542a.751.751,0,0,0,.671-.415l1.037-2.073A3.64,3.64,0,0,1,15.1,18.75h.625', 'M6.846,17.25,4.493,19.6a.749.749,0,0,0,.114,1.154l.977.652', 'M15.1,15.75a3.252,3.252,0,0,0,.42,2.506,1.609,1.609,0,0,1,.232,1.079l-.507,3.042a.75.75,0,0,0,.74.873H17.51a.751.751,0,0,0,.728-.568l.479-1.915a1.5,1.5,0,0,1,.555-.837l.068-.037a8.448,8.448,0,0,0,2.965-2.752h0']],
  SavingDogGuardIncrease: ['saving-dog-guard-increase', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5 5.25L22.5 0.75 18 0.75', 'M22.5.75,17.45,5.8a2.252,2.252,0,0,1-2.237.565L9.5,4.839a2.249,2.249,0,0,0-2.172.582L1.5,11.254', 'M19.3,21.076a5.565,5.565,0,0,0,3.2-4.954,4.6,4.6,0,0,0-.73-2.492A2.25,2.25,0,1,0,18.1,11.305l.008-.024a5.378,5.378,0,0,0-.707-.042l-1.814.015a5.259,5.259,0,0,0-.689.051A2.25,2.25,0,1,0,11.23,13.63a4.606,4.606,0,0,0-.73,2.492,5.565,5.565,0,0,0,3.2,4.954', 'M18.771,15.691l.479,4.939a2.2,2.2,0,0,1-2.119,2.624H15.869A2.2,2.2,0,0,1,13.75,20.63l.479-4.939', 'M16.5 19.504L16.5 20.254']],
  SavingSafeOpen: ['saving-safe-open', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.182,17.558A1.956,1.956,0,0,1,15.3,19H2.705A1.955,1.955,0,0,1,.75,17.045V5.205A1.955,1.955,0,0,1,2.705,3.25H15.3a1.955,1.955,0,0,1,1.941,1.722', 'M15,6.25V16H4.589a.838.838,0,0,1-.839-.839V7.089a.838.838,0,0,1,.839-.839H7.5', 'M20.25,19.75,15,16V6.25l5.25-3h2.022a.978.978,0,0,1,.978.978V18.772a.978.978,0,0,1-.978.978Z', 'M3.75 19L3.75 21.25', 'M14.25 19L14.25 21.25', 'M20.25 3.25L20.25 19.75', 'M12.75 16L11.304 13 7.446 13 6 16 12.75 16z', 'M10.5 10L10.5 7', 'M12 8.5L9 8.5', 'M17.25 4.972L17.25 17.607']],
  SavingBank: ['saving-bank', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.5 23.25L22.5 23.25', 'M22.5,8.25H1.5l9.689-5.762a1.5,1.5,0,0,1,1.622,0Z', 'M21 11.25L21 20.25 18 20.25 18 11.25', 'M13.5 11.25L13.5 20.25 10.5 20.25 10.5 11.25', 'M6 11.25L6 20.25 3 20.25 3 11.25']],
  SavingPiggyCoinsAlternate: ['saving-piggy-coins-alternate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,10.5a3,3,0,0,1-3,3', 'M6,6.8A8.318,8.318,0,0,0,2.6,11.25H.75v6H3.24a8.467,8.467,0,0,0,2.01,2.372V22.5a.75.75,0,0,0,.75.75H7.5a.75.75,0,0,0,.75-.75V21.259a9.512,9.512,0,0,0,6,.011V22.5a.75.75,0,0,0,.75.75h1.5a.75.75,0,0,0,.75-.75V19.637a7.941,7.941,0,0,0,3-6.137,8.053,8.053,0,0,0-3.757-6.706', 'M8.25,7.5a6.763,6.763,0,0,1,6,0', 'M8.250 3.750 A3.000 3.000 0 1 0 14.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 Z']],
  SavingBank1: ['saving-bank-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.5 23.25L22.5 23.25', 'M1.5 20.25L22.5 20.25', 'M3 9.75L3 17.25', 'M6 9.75L6 17.25', 'M10.5 9.75L10.5 17.25', 'M13.5 9.75L13.5 17.25', 'M18 9.75L18 17.25', 'M21 9.75L21 17.25', 'M22.5,6.75H1.5L11.189.988a1.5,1.5,0,0,1,1.622,0Z']],
  SavingSafe: ['saving-safe', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 21.750 L0.750 21.750 Z', 'M5.250 3.750 L20.250 3.750 L20.250 18.750 L5.250 18.750 Z', 'M3.75 21.75L3.75 23.25', 'M20.25 21.75L20.25 23.25', 'M3.75 8.25L6.75 8.25', 'M3.75 14.25L6.75 14.25', 'M10.050 11.250 A2.700 2.700 0 1 0 15.450 11.250 A2.700 2.700 0 1 0 10.050 11.250 Z', 'M12.75 8.55L12.75 6.75', 'M12.75 15.75L12.75 13.95', 'M15.45 11.25L17.25 11.25', 'M8.25 11.25L10.05 11.25', 'M9.986 14.432L11.061 13.357', 'M9.986 8.068L11.061 9.143', 'M15.514 14.432L14.439 13.357', 'M15.514 8.068L14.439 9.143']],
  SavingMoneyFlower: ['saving-money-flower', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.946 12.75L11.946 23.25', 'M11.946,23.25s-1.13-3.091-6.308-6.386', 'M3.661,19c1.026,1.116,2.642,1.523,3.623-.564C9.711,17,8.716,15.182,7.337,14.23a7.219,7.219,0,0,0-6.523.1C2.47,15.935,2.385,17.609,3.661,19Z', 'M11.946,23.25s1.13-3.091,6.309-6.386', 'M20.231,19c-1.025,1.116-2.642,1.523-3.622-.564-2.427-1.438-1.432-3.255-.054-4.207a7.222,7.222,0,0,1,6.524.1C21.422,15.935,21.508,17.609,20.231,19Z', 'M13.446,3.75H11.413a1.341,1.341,0,0,0-.5,2.587l2.063.826a1.342,1.342,0,0,1-.5,2.587H10.446', 'M11.946 3.75L11.946 3', 'M11.946 10.5L11.946 9.75', 'M5.946 6.750 A6.000 6.000 0 1 0 17.946 6.750 A6.000 6.000 0 1 0 5.946 6.750 Z']],
  SavingBankInternational: ['saving-bank-international', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.75 23.25L22.5 23.25', 'M11.25 15.75L11.25 23.25', 'M14.25 15.75L14.25 23.25', 'M18 15.75L18 23.25', 'M21 15.75L21 23.25', 'M23.25,15.75H9l6.575-4.321a.933.933,0,0,1,1.1,0Z', 'M5.737,21.347a11.253,11.253,0,1,1,17.49-10.1', 'M6.844,13.493a26.32,26.32,0,0,1,.232-5.928A16.27,16.27,0,0,1,9.289,1.079', 'M0.775 11.25L6.75 11.25', 'M2.482 6L21.518 6', 'M1.686 16.5L6 16.5', 'M14.711,1.079a17.056,17.056,0,0,1,2.312,7.2']],
  SavingBear: ['saving-bear', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.386,22.823c.075.267.121.427.121.427h2.709a.75.75,0,0,0,.712-.987l-.75-2.25A3.005,3.005,0,0,0,14.937,17.9', 'M18.007,9l1,.335a4.509,4.509,0,0,0,2.519.1l.795-.2a.751.751,0,0,1,.932.728v1.575a.75.75,0,0,1-.415.671L20.257,13.5', 'M21,13.87l-.974-.487A3.855,3.855,0,0,1,18.007,9l1.652-.826a5.153,5.153,0,0,0,2.848-4.608A.566.566,0,0,0,21.941,3l-2.895-.552a3,3,0,0,0-1.973.3.4.4,0,0,1-.314,0,.408.408,0,0,1-.217-.228l-.108-.287a1.125,1.125,0,0,0-2.105.793.8.8,0,0,1-.447,1.022L12.757,4.5A7.9,7.9,0,0,0,10.38,6.37,7.288,7.288,0,0,1,6.8,8.986a7.825,7.825,0,0,0-3.616,2.492,1.641,1.641,0,0,0-2.159-.184c-.646.7-.065,1.981.9,2.6a4.52,4.52,0,0,0,.044,3.192A4.707,4.707,0,0,0,3.664,19l1.41,3.761a.751.751,0,0,0,.7.487H7.642a.75.75,0,0,0,.735-.6l.8-3.971.8-.317a10.3,10.3,0,0,0,4.544-3.542,6.377,6.377,0,0,0,2.777,1.189l2.488.414a.749.749,0,0,0,.748-.324l.76-1.139A.751.751,0,0,0,21,13.87Z']],
  SavingBullDecrease: ['saving-bull-decrease', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.669,14.211l.747,1.867A1.878,1.878,0,0,1,13,18.1l-1.455,1.454a1.655,1.655,0,0,0-.483,1.168,1.652,1.652,0,0,1-1.13,1.567l-1.09.364a1.88,1.88,0,0,1-1.186,0l-1.09-.364a1.651,1.651,0,0,1-1.129-1.567,1.656,1.656,0,0,0-.484-1.168L3.5,18.1a1.878,1.878,0,0,1-.415-2.023l.695-1.736', 'M9 18.246L7.5 18.246', 'M13.086,15.253,14.662,14.2a2.442,2.442,0,0,0,1.088-2.033h0a2.443,2.443,0,0,0-2.443-2.443h0a1.467,1.467,0,0,1-1.22-.653l-1.44-2.159A3.53,3.53,0,0,0,9.266,8.99a.991.991,0,0,1-1.016.746A.988.988,0,0,1,7.234,8.99,3.53,3.53,0,0,0,5.853,6.914L4.413,9.073a1.467,1.467,0,0,1-1.22.653h0A2.443,2.443,0,0,0,.75,12.169h0A2.442,2.442,0,0,0,1.838,14.2l1.576,1.051', 'M23.25 7.75L23.25 12.25 18.75 12.25', 'M4.266 3.68L2.25 1.664', 'M23.25,12.25,18.2,7.2a2.252,2.252,0,0,0-2.237-.565l-1.456.39']],
  SavingSafe1: ['saving-safe-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 3.750 L23.250 3.750 L23.250 21.750 L0.750 21.750 Z', 'M5.250 6.750 L20.250 6.750 L20.250 18.750 L5.250 18.750 Z', 'M3.75 21.75L3.75 23.25', 'M20.25 21.75L20.25 23.25', 'M3.75 11.25L6.75 11.25', 'M3.75 15.75L6.75 15.75', 'M13.875,14.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M16.875,14.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M13.875,10.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M16.875,10.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  SavingMoneyEgg: ['saving-money-egg', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.892,10.844a2.221,2.221,0,0,0,1.858.875c1.139,0,2.062-.693,2.062-1.547s-.923-1.546-2.062-1.546-2.062-.693-2.062-1.548.923-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M12.75 11.719L12.75 12.75', 'M12.75 4.5L12.75 5.531', 'M19.5,12.375C19.5,10.875,17.636.75,12.75.75S6,10.875,6,12.375', 'M3.75,15.75a9.15,9.15,0,0,0,18,0Z', 'M1.5 14.25L3.75 15.75', 'M2.25 18L4.085 17.082', 'M20.191 19.461L22.5 21']],
  SavingMoneySeedling: ['saving-money-seedling', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(3.48 -2.393) rotate(30.012)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(37.439 5.27) rotate(141.884)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(5.993 -2.067) rotate(21.429)'
  }], ['M1.585 2.292 L10.823 2.292 L10.823 8.299 L1.585 8.299 Z', 'M13.055 6.099 L22.564 6.099 L22.564 12.106 L13.055 12.106 Z', 'M11.952 20.25L11.952 0.933', 'M6.134,4.764a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M17.647,8.769a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M8.952,23.25l-.79-2.341a.5.5,0,0,1,.475-.659h6.62a.5.5,0,0,1,.475.659l-.78,2.341', 'M5.457 12.927 L11.457 12.927 L11.457 16.677 L5.457 16.677 Z']],
  SavingBullIncrease: ['saving-bull-increase', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.831,13.714l-.747,1.868A1.876,1.876,0,0,0,10.5,17.6l1.455,1.455a1.654,1.654,0,0,1,.484,1.168,1.652,1.652,0,0,0,1.129,1.567l1.09.363a1.866,1.866,0,0,0,1.186,0l1.09-.363a1.652,1.652,0,0,0,1.129-1.567,1.654,1.654,0,0,1,.484-1.168L20,17.6a1.876,1.876,0,0,0,.415-2.022l-.7-1.736', 'M16 17.75L14.5 17.75', 'M10.414,14.756,8.838,13.705A2.442,2.442,0,0,1,7.75,11.673h0A2.443,2.443,0,0,1,10.193,9.23h0a1.467,1.467,0,0,0,1.22-.653l1.44-2.16a3.53,3.53,0,0,1,1.381,2.076,1.065,1.065,0,0,0,2.032,0,3.53,3.53,0,0,1,1.381-2.076l1.44,2.16a1.467,1.467,0,0,0,1.22.653h0a2.443,2.443,0,0,1,2.443,2.443h0a2.442,2.442,0,0,1-1.088,2.032l-1.576,1.051', 'M22.75 5.75L22.75 1.25 18.25 1.25', 'M9.754,5.339a2.249,2.249,0,0,0-2.172.582L1.75,11.754', 'M22.75 1.25L19.811 4.189']],
  SavingDogGuardDecrease: ['saving-dog-guard-decrease', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.55,21.072a5.564,5.564,0,0,0,3.2-4.954,4.594,4.594,0,0,0-.73-2.491A2.25,2.25,0,1,0,8.351,11.3l.008-.024a5.378,5.378,0,0,0-.707-.042l-1.814.015a5.438,5.438,0,0,0-.689.051A2.25,2.25,0,1,0,1.48,13.627a4.6,4.6,0,0,0-.73,2.491,5.564,5.564,0,0,0,3.2,4.954', 'M9.021,15.687,9.5,20.626A2.2,2.2,0,0,1,7.381,23.25H6.119a2.1,2.1,0,0,1-1.483-.614A2.106,2.106,0,0,1,4,20.626l.479-4.939', 'M6.75 19.5L6.75 20.25', 'M23.25 6.754L23.25 11.254 18.75 11.254', 'M23.25,11.254,18.2,6.2a2.251,2.251,0,0,0-2.237-.564L10.254,7.165a2.251,2.251,0,0,1-2.172-.583L2.25.75']],
  SavingMoneyTree: ['saving-money-tree', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.5 20.25L12.5 15.75', 'M9.5,23.25l-.781-2.342a.5.5,0,0,1,.475-.658h6.612a.5.5,0,0,1,.475.658L15.5,23.25', 'M18.054,17.188A2.5,2.5,0,0,0,20,14.75c0-1.225-1.5-2.5-3-2.454A9.49,9.49,0,0,0,18.5,7.25s.562-6.5-6.194-6.5S6.5,7.25,6.5,7.25a8.4,8.4,0,0,0,.5,3c-2,0-3.5,1-3.5,3,0,2.236,1.067,3.5,3,3.5', 'M12.5,17.75a3.891,3.891,0,0,1-3-1.5', 'M12.5,17.75a3.891,3.891,0,0,0,3-1.5', 'M14.545,5.352H11.477c-.673,0-1.022.2-1.022,1.023,0,1.337,4.09,2.754,4.09,4.091a.9.9,0,0,1-1.022,1.023H10.455', 'M12.5 5.352L12.5 3.818', 'M12.5 13.023L12.5 11.489']],
  SavingWalletInternational: ['saving-wallet-international', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,20.25v1.227a1.7,1.7,0,0,1-1.607,1.773H12.857a1.7,1.7,0,0,1-1.607-1.773v-6.2A1.7,1.7,0,0,1,12.857,13.5h8.036A1.7,1.7,0,0,1,22.5,15.273v.977', 'M21.04,13.507l-1.282-2.565a.8.8,0,0,0-1.074-.357L12.857,13.5', 'M22.45,20.25a.8.8,0,0,0,.8-.8v-2.4a.8.8,0,0,0-.8-.8h-2a2,2,0,0,0,0,4Z', 'M5.737,21.347A11.251,11.251,0,1,1,22.756,8.693q.073.242.137.483', 'M7.981,19.4A26.114,26.114,0,0,1,7.076,7.565,16.27,16.27,0,0,1,9.289,1.079', 'M0.775 11.25L11.25 11.25', 'M2.482 6L21.518 6', 'M1.687 16.5L7.245 16.5', 'M14.711,1.079a14.9,14.9,0,0,1,2,5.309q.177.87.286,1.737']]
};
exports["default"] = _default;